/**
 * Class that represents a LOV enpoint
 */
export class LovEndpoint {

    constructor(
        public key: string,
        public endpoint: string) {
    }

}